module.exports = __webpack_public_path__ + "img/nps-info-unhappy.1a9b2298.svg";